import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../themes/confirm_hyg.scss';
import '../themes/global.scss';

import {
  FETCH_JOB_ACTION,
  addFavoriteProfessional,
  blockProfessional,
  fetchJob,
  hideMessage,
} from '../actions';
import { createErrorObjectSelector, createLoadingSelector } from '../api/selectors';
import CustomSpinner from '../commonComponents/CustomSpinner';
import history from '../history';
import blockCross from '../images/block-cross.svg';
import blockUserIcon from '../images/block-user.svg';
import favoriteHeartSummary from '../images/favorite-heart-summary.svg';
import heartOutline from '../images/heart-outline.svg';
import receiptsShiftIcon from '../images/receipts-shift-icon.svg';
import { Colors } from '../themes/colors';
import defaultProfileImage from '../images/defaultProfileImage.png';
import defaultPersonImage from '../images/defaultPerson.svg';

import BackButton from '../commonComponents/BackButton';
import Button from '../commonComponents/Button';
import CustomPortal from '../commonComponents/CustomPortal';
import { Links } from '../constants';
import CancelledJob from './CancelledJob';
import { getJobStatus } from './Dashboard/ReceiptList/utils';
import Tooltip from './Tooltip';
import { isEmployeeOption, isEmployeeOptionShift } from './WorkerClassification/utils';
import ConfirmPopup from './shared/ConfirmPopup';
import PencilIcon from '../images/icons/Pencil';

const convenienceFeeTooltip = 'GoTu charges a 3.5% convenience fee on Credit Card transactions. If you do not wish to be charged the convenience fee, please update your billing to E-check/ACH.';

class JobDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFee: false,
      showCancellationPopup: false,
      showUnableToAddModal: false,
      showUnableToAddBlockedModal: false,
      showBlockConfirmPopup: false,
    };
  }

  componentDidMount() {
    const { jobId } = this.props.match.params;
    const { fetchJob, job } = this.props;
    fetchJob({ jobId });
  }

  componentDidUpdate() {
    const { jobId } = this.props.match.params;
    const isPrevScreenFeedback = this.props.location.state?.isPrevScreenFeedback;

    const { job, history, user } = this.props;
    if (job && !job.isFeedbackSubmited && !isPrevScreenFeedback) {
      history.push(`/dashboard/job/${jobId}/feedback`);
    }
  }

  showEodButton = () => {
    const { job } = this.props;
    if (job.status === 'pay-out' && !job.isFeedbackSubmited) {
      return (
        <div 
          onClick={() => history.push(`/dashboard/job/${job?.id}/feedback`)}
          style={{
            position: 'absolute',
            top: '50%', 
            right: '-25px', 
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}>
          <PencilIcon color={Colors.secondary_500} />
        </div>
      );
    }
    return null;
  };

  addToFavorite = () => {
    const { addFavoriteProfessional, job, user } = this.props;
    const isBlocked = user?.blocked_hygienist?.includes(job?.offer_final_reciever?.id);

    if (user?.favoriteProfessionals.length >= 10) {
      this.setState({ showUnableToAddModal: true });
    } else if (isBlocked) {
      this.setState({ showUnableToAddBlockedModal: true });
    } else {
      addFavoriteProfessional(job?.offer_final_reciever?.id);
    }
  }

  blockProfessional = () => {
    const { job, blockProfessional } = this.props;

    blockProfessional({ user: job?.offer_final_reciever });
  };

  hygInfo = () => {
    const { user, job, history } = this.props;

    const hasProfessional = !!job?.offer_final_reciever

    const isFavorite = job?.offer_final_reciever?.isFavorite;
    const blockedProfessional = user?.blocked_hygienist?.includes(job?.offer_final_reciever?.id);

    const favoriteButtonRef = React.createRef(null);
    const blockButtonRef = React.createRef(null);

    return (
      <div
        style={{
          position: 'relative',
          backgroundColor: Colors.white,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 50,
          paddingBottom: 30,
          boxShadow: '0px 3px 10px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
          zIndex: 1,
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
          }}
          >
            <div style={{ position: 'absolute', left: 50 }}>
              <BackButton />
            </div>

            {hasProfessional && (job?.status !== 'filled' && job?.status !== 'cancelled') && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '80%',
                  display: 'flex',
                  columnGap: 24,
                }}
              >
                <div
                  style={{
                    width: 75,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    rowGap: 8,
                  }}
                >
                  <button
                    ref={favoriteButtonRef}
                    type="button"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: isFavorite ? Colors.primary_200 : Colors.primary_500,
                    }}
                    onClick={this.addToFavorite}
                    disabled={isFavorite}
                  >
                    <img src={heartOutline} alt="heart_outline" />
                  </button>

                  <p
                    style={{
                      fontFamily: 'Nunito',
                      fontSize: 14,
                      color: isFavorite ? Colors.neutral_400 : Colors.neutral_600,
                      textAlign: 'center',
                      margin: 0,
                    }}
                  >
                    {isFavorite ? 'Added to Favorites' : 'Add to Favorites'}
                  </p>
                </div>

                <div
                  style={{
                    width: 50,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    rowGap: 8,
                  }}
                >
                  <button
                    ref={blockButtonRef}
                    type="button"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: blockedProfessional
                        ? Colors.secondary_100 : Colors.secondary_500,
                    }}
                    onClick={() => this.setState({ showBlockConfirmPopup: true })}
                    disabled={blockedProfessional}
                  >
                    <img src={blockUserIcon} alt="block_user_icon" />
                  </button>

                  <p
                    style={{
                      fontFamily: 'Nunito',
                      fontSize: 14,
                      color: blockedProfessional ? Colors.neutral_400 : Colors.neutral_600,
                      textAlign: 'center',
                      margin: 0,
                    }}
                  >
                    {blockedProfessional ? 'Blocked Professional' : 'Block Professional'}
                  </p>
                </div>
              </div>
            )}

            <h1
              className="title global_font"
              style={{
                fontSize: 28,
                fontWeight: 700,
                textAlign: 'center',
                width: '350px',
                color: Colors.neutral_600,
                flex: 1,
              }}
            >
              Job Summary
            </h1>
          </div>

          <div
            style={{
              display: 'flex',
              columnGap: '20px',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            {job?.offer_final_reciever?.profile_image ? (
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  border: job.offer_final_reciever?.isFavorite ? '3px solid #B764EB' : 'none',
                  borderRadius: '50%',
                  padding: 3,
                }}
              >
                <img
                  src={job.offer_final_reciever?.profile_image}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                  alt="profile_image"
                />

                {job.offer_final_reciever?.isFavorite && <img src={favoriteHeartSummary} style={{ position: 'absolute', top: '65%', left: '70%' }} alt="favorite_heart_summary" />}
              </div>
            ) : (
              <img
                src={hasProfessional ? defaultProfileImage : defaultPersonImage}
                alt="profile_image"
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: 100,
                  objectFit: 'cover',
                  marginRight: 28,
                }}
              />
            )}
            {hasProfessional ?
              <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    className="global_font f-20"
                    style={{ color: Colors.neutral_600, fontWeight: 'bold', marginRight: 10 }}
                  >
                    {`${job.offer_final_reciever?.first_name || ''} ${job.offer_final_reciever?.last_name || ''}`}
                    {' '}
                    |
                  </span>

                  <div
                    className="global_font f-20"
                    style={{
                      marginLeft: 20,
                      color: Colors.secondary_500,
                      fontWeight: 'bold',
                      margin: 0,
                      cursor: 'pointer',
                    }}
                    onClick={() => history.push(`/dashboard/candidate/${job?.id}`)}
                  >
                    Profile
                  </div>
                </div>
                <p className="global_font std_font" style={{ color: Colors.neutral_600 }}>
                  {job.professionName || ''}
                </p>
                {job.offer_final_reciever.license?.license ? (
                  <p className="global_font std_font" style={{ color: Colors.neutral_600 }}>
                    License:
                    {' '}
                    {job.offer_final_reciever.license?.license || ''}
                  </p>
                ) : (
                  <div />
                )}
                <p className="global_font std_font" style={{ color: Colors.neutral_600 }}>
                  {job.offer_final_reciever.address[0].formatted_address}
                </p>
              </div>
              : 
              <div>
                <span
                  className="global_font f-20"
                  style={{ color: Colors.neutral_600, fontWeight: 'bold', marginLeft: -24}}
                >
                  Shift Unfilled
                </span>
              </div>
            }
          </div>

          {this.state.showUnableToAddModal ? (
            <CustomPortal
              title="Unable to Add to Favorites"
              text="You have already reached the maximum of 10 Favorite professionals. To add this professional, please remove someone else from your Favorites List."
              isSuccess
              submitPressed={() => this.setState({ showUnableToAddModal: !this.state.showUnableToAddModal })}
            />
          ) : null}

          {this.state.showUnableToAddBlockedModal && (
            <ConfirmPopup
              title="Unable to Add to Favorites"
              description="To add this professional to your Favorites, please contact Customer Support to remove this professional from your blocked list."
              rightButtonText="Close"
              rightButtonAction={() => this.setState({ showUnableToAddBlockedModal: false })}
            />
          )}
        </div>
      </div>
    );
  };

  handleLearnMore = () => {
    window.open(Links.bankPayments);
    this.setState({ showFee: false });
  };

  handleOKClicked = () => {
    this.setState({ showFee: false });
  };

  cancelBtnDisplay = () => {
    const { job } = this.props;
    const current_time = new Date();

    if (
      job.job_status === 'filled'
      && !job.is_cancelled
      && moment(job.job_datetime).toDate() > current_time
    ) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 8,
          }}
        >
          <Button
            style={{
              backgroundColor: Colors.secondary_500,
              width: 320,
              height: 50,
            }}
            text="Cancel Job"
            onClick={() => this.setState({ showCancellationPopup: true })}
          />
        </div>
      );
    }

    return <></>;
  };

  transactionHistoryBtn = () => {
    const { job } = this.props;

    if (
      job?.transactions?.length
      && (job.status === 'filled'
      || job.status === 'complete'
      || job.status === 'pay-out'
      || job.status === 'cancelled')
    ) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 8,
          }}
        >
          <Button
            style={{
              backgroundColor: Colors.neutral_400,
              width: 320,
              height: 50,
            }}
            Icon={receiptsShiftIcon}
            text="Transaction History"
            onClick={() => history.push(`/dashboard/receipts/transactions/${job?.id}`)}
          />
        </div>
      );
    }

    return <></>;
  };

  renderRow = ({ title, description, timezone, rightComponent }) => (
    <div className="row_style">
      <div style={{ display: 'flex', alignItems: 'center', columnGap: 10 }}>
        <p className="global_font bold_font" style={{ margin: 0, color: Colors.neutral_600 }}>
          {title}
        </p>

        {timezone && (
          <div style={{ backgroundColor: Colors.neutral_300, padding: '1px 4px', borderRadius: 100 }}>
            <p
              style={{
                margin: 0,
                fontSize: 12,
                fontWeight: 'bold',
                color: Colors.white,
              }}
            >
              EDT
            </p>
          </div>
        )}
      </div>

      <p
        className="global_font"
        style={{
          margin: 0, color: Colors.neutral_600, fontSize: 18, textAlign: 'left',
        }}
      >
        {description}
      </p>
      {rightComponent}
    </div>
  )

  renderFilledJobInfo = () => {
    const { job, user } = this.props;
    const chargeDate = moment(job?.job_datetime).subtract(28, 'days').format('MM/DD/YYYY');
    const startDiff = moment(job?.job_datetime).diff(moment(), 'days');
    return (
      <>
        {this.renderRow({ 
          title: `Professional Pay ${job?.totalHours?.toFixed(2)} hours:`, 
          description: `$ ${job.amount?.toFixed(2) || ''}`, 
        })}
        {this.renderRow({
          title:
            job.tm_fee_percent !== 0 ? `Service Fee 
        (${job.tm_fee_percent}%):` : 'Service Fee:',

          description: `$${job.tm_fee?.toFixed(2)}`,
        })}
        {isEmployeeOptionShift(job) && this.renderRow({
          title: 'Employee Option Fee:',
          description: job.employeeOptionFee ? `$${job.employeeOptionFee?.toFixed(2)}` : '$--.--',
        })}
        {job.convenience_fee_percent !== 0 ? (
          <div className="row_style">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <p className="global_font bold_font" style={{ margin: 0, color: Colors.DarkGray }}>
                Convenience Fee
                {' '}
                {`(${job.convenience_fee_percent.toFixed(1) || '0'}%)`}
                :
                <span
                  style={{
                    marginLeft: '5px',
                    position: 'relative',
                    top: '5px',
                  }}
                >
                  <Tooltip content={convenienceFeeTooltip} />
                </span>
              </p>
            </div>
            <p
              className="global_font"
              style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}
            >
              {`$${job.convenience_fee.toFixed(2) || '0'}`}
            </p>
          </div>
        ) : null}
        {job?.multi_day_booking && startDiff > 28
          ? (this.renderRow({ title: 'Professional pay charge date', description: chargeDate }))
          : (<div />)}
        <div
          className="row_style"
          style={{
            marginTop: 10,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 10,
            gap: 10,
          }}
        >
          <p className="global_font bold_font" style={{ margin: 0, color: Colors.success_500 }}>
            Total Pay:
          </p>
          <p className="global_font" style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}>
            $
            {' '}
            {job.total.toFixed(2)}
          </p>
        </div>
        {job?.cancelPerformedBy && (
          this.renderRow({
            title: 'Cancelled by:',
            description: `${job?.cancelPerformedBy?.first_name || ''} ${job?.cancelPerformedBy?.last_name || ''
            }`,
          })
        )}
        {job?.confirmPerformedBy && (
          this.renderRow({
            title: 'Scheduled By:',
            description: `${job?.confirmPerformedBy?.first_name || ''} ${job?.confirmPerformedBy?.last_name || ''
            }`,
          })
        )}

      </>
    );
  }

  renderFilledCancelledJobInfo = () => {
    const { job, user } = this.props;
    return (
      <div>
        {this.renderRow({ title: 'Cancellation Fee:', description: `$ ${job.cancellation_fee?.toFixed(2) || ''}` })}
        {this.renderRow({
          title:
            job.tm_fee_percent !== 0 ? `Service Fee 
        (${job.tm_fee_percent}%):` : 'Service Fee:',
          description: `$${job.tm_fee?.toFixed(2)}`,
        })}
        {isEmployeeOptionShift(job) && this.renderRow({
          title: 'Employee Option Fee:',
          description: job.employeeOptionFee ? `$${job.employeeOptionFee?.toFixed(2)}` : '$--.--',
        })}
        {job.convenience_fee_percent !== 0 ? (

          <div className="row_style">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <p className="global_font bold_font" style={{ margin: 0, color: Colors.DarkGray }}>
                Convenience Fee
                {' '}
                {`(${job.convenience_fee_percent.toFixed(1) || '0'}%)`}
                :
                <span
                  style={{
                    marginLeft: '5px',
                    position: 'relative',
                    top: '5px',
                  }}
                >
                  <Tooltip content={convenienceFeeTooltip} />
                </span>
              </p>
            </div>
            <p
              className="global_font"
              style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}
            >
              {`$${job.convenience_fee.toFixed(2) || '0'}`}
            </p>
          </div>
        ) : null}
        <div className="row_style_bold">
          <p className="global_font bold_font" style={{ margin: 0, color: Colors.neutral_600 }}>
            Refund Total
            {' '}
            {job.card_name}
            {' '}
            *
            {job.card_number}
          </p>
          <p className="global_font" style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}>
            $
            {' '}
            {job.total_refund.toFixed(2)}
          </p>
        </div>
      </div>
    );
  }

  chatBtnDisplay = () => {
    const { job, history } = this.props;
    const current_time = new Date();
    if (
      job.job_status === 'filled'
      && !job.is_cancelled
      && moment(job.job_datetime_end).toDate() > current_time
      && job.offer_final_reciever
    ) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 40,
          }}
        >
          <Button
            color="primary"
            style={{
              width: 320,
              height: 50,
            }}
            text="Contact Professional"
            onClick={() => history.push(`/dashboard/chat/${job?.id}`, { jobId: job?.id })}
          />
        </div>
      );
    }

    return <></>;
  };

  renderSummaryContent = () => {
    const { job } = this.props;

    if (job.status === 'filled' || job.status === 'complete' || job.status === 'pay-out') {
      return this.renderFilledJobInfo();
    } if (job.status === 'cancelled' && job.offer_final_reciever) {
      return this.renderFilledCancelledJobInfo();
    }

    return <></>;
  }

  render() {
    const {
      job, isLoading, childOffices,
    } = this.props;
    const { showFee, showCancellationPopup, showBlockConfirmPopup } = this.state;

    if (isLoading || !job) {
      return (
        <div className="component_container" ref={(element) => (this.divRef = element)}>
          <div className="floating_container">
            <CustomSpinner isLoading={isLoading} />
          </div>
        </div>
      );
    }
    const professionalName = `${job?.offer_final_reciever?.first_name} ${job?.offer_final_reciever?.last_name}`;
    const isFavorite = job?.offer_final_reciever?.isFavorite;
    return (
      <div className="component_container" ref={(element) => (this.divRef = element)}>
        <div style={{
          width: '100%',
          boxShadow: '0px 3px 10px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
        }}
        >
          {this.hygInfo()}

          <div style={{
            display: 'flex', justifyContent: 'center', margin: '0 16px 16px 16px', background: Colors.white, boxShadow: '0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
          }}
          >
            <div
              style={{
                width: 500,
                display: 'flex',
                flexDirection: 'column',
                marginTop: 40,
                paddingBottom: 60,
              }}
            >
              <div
                className="global_font"
                style={{
                  margin: 0,
                  fontSize: 18,
                  fontWeight: 'bold',
                  color: Colors.DarkGray,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  alignSelf: "center",
                  marginBottom: 16
                }}
              >
                <div className="global_font f-18" style={{ color: Colors.neutral_600, fontWeight: 'bold' }}>
                  Status:
                </div>
                <span
                  style={{
                    fontWeight: 'normal',
                    textTransform: 'uppercase',
                    color: getJobStatus(job?.status)?.color,
                  }}
                >
                  {getJobStatus(job?.status)?.label || job?.status}
                </span>
              </div>

              {childOffices.length !== 0 ? (
                <div className="row_style">
                  <p className="global_font bold_font" style={{ margin: 0, color: Colors.neutral_600 }}>
                    Office:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}
                  >
                    {job.offer_owner?.office_name}
                  </p>
                </div>
              ) : (
                <div />
              )}

              {this.renderRow({ title: 'Date:', description: job.local_date })}

              <div className="row_style">
                <p className="global_font bold_font" style={{ margin: 0, color: Colors.neutral_600 }}>
                  Profession:
                </p>
                <p
                  className="global_font"
                  style={{
                    margin: 0, color: Colors.neutral_600, fontSize: 18, textTransform: 'capitalize',
                  }}
                >
                  {job.professionName || ''}
                </p>
              </div>

              {this.renderRow({ title: 'Preferred Specialty:', description: job?.specialty?.split('_')?.[1] || 'General' })}

              {this.renderRow({ 
                title: 'Hours:', 
                description: `${job.local_start_time} - ${job.local_end_time}`,
                timezone: true,
                rightComponent: this.showEodButton(),
              })}

              <div className="row_style">
                <p className="global_font bold_font" style={{ margin: 0, color: Colors.neutral_600 }}>
                  Hourly Rate:
                </p>
                <p className="global_font" style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}>
                  $
                  {job.rate.toFixed(2)}
                </p>
              </div>
              {this.renderRow({ title: `Break ${job.is_lunch_break_paid ? '(Paid)' : '(Unpaid)'}`, description: `${job.lunch_break_time} min` })}

              {this.renderRow({ title: 'Auto-Confirm:', description: job.autoFill ? 'On' : 'Off' })}

              {job?.cancelPerformedBy && (
                this.renderRow({
                  title: 'Cancelled by:',
                  description: `${job?.cancelPerformedBy?.first_name || ''} ${job?.cancelPerformedBy?.last_name || ''
                  }`,
                })
              )}

              {this.renderSummaryContent()}

              {this.chatBtnDisplay()}

              {this.cancelBtnDisplay()}

              {this.transactionHistoryBtn()}
            </div>
          </div>
        </div>
        {showCancellationPopup ? <CancelledJob closePopup={() => this.setState({ showCancellationPopup: false })} /> : null}
        {showBlockConfirmPopup && (
          <ConfirmPopup
            title="Block Professional"
            description={isFavorite ? `To block this professional, they must be removed from your Favorites list. Would you like to continue with removing ${professionalName} from your Favorites and blocking them?`
              : 'Are you sure you want to block this professional from working with you again?'}
            leftButtonText="Go Back"
            leftButtonAction={() => this.setState({ showBlockConfirmPopup: false })}
            rightButtonText="Continue"
            rightButtonAction={this.blockProfessional}
            Icon={() => <img src={blockCross} style={{ marginBottom: 20 }} alt="block_cross" />}
            closePopup={() => this.setState({ showBlockConfirmPopup: false })}
          />
        )}
      </div>
    );
  }
}
const actions = [FETCH_JOB_ACTION];
const loadingSelector = createLoadingSelector(actions);
const errorSelector = createErrorObjectSelector(actions);

const mapStateToProps = (state, props) => ({
  error: errorSelector(state),
  job: props.match.params.jobId === state.job.job?.id ? state.job.job : null,
  isLoading: loadingSelector(state),
  user: state.user.user,
  favoriteProfessionals: state.user.favoriteProfessionals,
  childOffices: state.user.childOffices,
});

export default connect(mapStateToProps, {
  fetchJob, hideMessage, addFavoriteProfessional, blockProfessional,
})(JobDetails);
